import { NgModule } from '@angular/core';
import { TopBannerComponent } from './top-banner/top-banner.component';

@NgModule({
  imports: [TopBannerComponent],
  exports: [TopBannerComponent],
})
export class NotificationModule {}
